// @ts-nocheck
import { getCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { addCart, AddCartApiParameter } from "@insite/client-framework/Services/CartService";
import { GetVmiLocationsApiParameter } from "@insite/client-framework/Services/VmiLocationService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState, isCartEmpty } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import removeCart from "@insite/client-framework/Store/Data/Carts/Handlers/RemoveCart";
import loadVmiLocations from "@insite/client-framework/Store/Data/VmiLocations/Handlers/LoadVmiLocations";
import { getVmiLocationsDataView } from "@insite/client-framework/Store/Data/VmiLocations/VmiLocationsSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import setIsReorderConfirmationModalOpen from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetIsReorderConfirmationModalOpen";
import setNextAction from "@insite/client-framework/Store/Pages/VmiBins/Handlers/SetNextAction";
import translate from "@insite/client-framework/Translate";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import TwoButtonModal, { TwoButtonModalStyles } from "@insite/content-library/Components/TwoButtonModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { setCookie } from "@insite/mobius/utilities/cookies";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Radio, { RadioPresentationProps } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps } from "@insite/mobius/RadioGroup";
import constants from "@store/constants";
import convertSelectorToHooks from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

export const getShowNavigationModeMenu = (state: ApplicationState) => {
    const session = getSession(state);
    const isAuthenticated = session.isAuthenticated && !session.isGuest;
    const vmiEnabled = getSettingsCollection(state).orderSettings.vmiEnabled;

    return Boolean(
        isAuthenticated &&
            vmiEnabled &&
            (session.userRoles?.toLowerCase().indexOf("vmi_admin") !== -1 ||
                session.userRoles.toLowerCase().indexOf("vmi_user") !== -1),
    );
};

export const useShowNavigationModeMenu = convertSelectorToHooks(getShowNavigationModeMenu);
/* Starter Custom Code - End */

export const NavigationModeCookieName = "NavigationMode";
export const NavigationModeState = "NavigationModeState";

interface OwnProps {
    extendedStyles?: NavigationModeMenuStyles;
    // Starter Custom Code
    setModalOverlayScrimRef?: (ref: React.Ref<HTMLDivElement>) => void;
    onChange?: (newValue: string) => void;
}

/* Starter Custom Code - Start */
const getVmiLocationsParameter = {
    ...constants.vmi.locationsApiParameters,
    pageSize: 1, // get first location
} as GetVmiLocationsApiParameter;
/* Starter Custom Code - End */

const mapStateToProps = (state: ApplicationState) => {
    const session = getSession(state);
    const isAuthenticated = session.isAuthenticated && !session.isGuest;
    const vmiEnabled = getSettingsCollection(state).orderSettings.vmiEnabled;
    const cart = getCurrentCartState(state).value;

    return {
        currentMode: getCookie(NavigationModeCookieName) || "Storefront",
        displayModeSwitch: getShowNavigationModeMenu(state), // Starter Custom Code
        vmiDashboardPageUrl: getPageLinkByPageType(state, "VmiDashboardPage")?.url,
        homePageUrl: getPageLinkByPageType(state, "HomePage")?.url,
        cartPageLink: getPageLinkByPageType(state, "CartPage")?.url,
        cart,
        isCartEmpty: isCartEmpty(cart),
        vmiLocationsDataView: getVmiLocationsDataView(state, getVmiLocationsParameter),
        getVmiLocationsParameter,
        selectedLocationId: state.pages.vmiBins.getVmiBinsParameter.vmiLocationId,
        cartRequestInProcess: state.pages.vmiBins.cartRequestInProcess,
        isReorderConfirmationModalOpen: state.pages.vmiBins.isReorderConfirmationModalOpen,
        hasChangeLastQty:
            state.pages.vmiBins.selectVmiBinsChangedQty &&
            Object.keys(state.pages.vmiBins.selectVmiBinsChangedQty).length > 0,
    };
};

const mapDispatchToProps = {
    removeCart,
    loadVmiLocations,
    loadCurrentCart,
    setIsReorderConfirmationModalOpen,
    setNextAction,
};

export interface NavigationModeMenuStyles {
    currencyWrapper?: InjectableCss;
    navigationModeSelect?: SelectPresentationProps;
    navigationConfirmModal?: TwoButtonModalStyles;
    navigationConfirmMessage?: TypographyProps;
    navigationConfirmQuestion?: TypographyProps;
    // Starter Custom Code
    radioGroup?: RadioGroupProps;
    radio?: RadioPresentationProps;
}

export const navigationModeMenuStyles: NavigationModeMenuStyles = {
    navigationConfirmMessage: { variant: "p" },
    navigationConfirmQuestion: { variant: "p" },
    radioGroup: { horizontal: true, sizeVariant: "small" },
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export const NavigationModeMenu = ({
    currentMode,
    displayModeSwitch,
    vmiDashboardPageUrl,
    homePageUrl,
    cartPageLink,
    cart,
    isCartEmpty,
    history,
    removeCart,
    extendedStyles,
    loadVmiLocations,
    vmiLocationsDataView,
    getVmiLocationsParameter,
    loadCurrentCart,
    selectedLocationId,
    cartRequestInProcess,
    isReorderConfirmationModalOpen,
    hasChangeLastQty,
    setIsReorderConfirmationModalOpen,
    setNextAction,
    // Starter Custom Code
    setModalOverlayScrimRef,
    onChange,
}: Props) => {
    const styles = useMergeStyles("navigationModeMenu", navigationModeMenuStyles, extendedStyles);
    const [navigationHeaderText, setNavigationHeaderText] = useState<string>("");
    const [navigationMessage, setNavigationMessage] = useState<JSX.Element>();
    const [navigationCurrentMode, setNavigationCurrentMode] = useState<string>(currentMode);
    const [navigationNewMode, setNavigationNewMode] = useState<string>(currentMode);
    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState<boolean>(false);

    const navigationModeChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.currentTarget.value;

        if (!isReorderConfirmationModalOpen && hasChangeLastQty && value !== "Vmi") {
            setIsReorderConfirmationModalOpen({ isReorderConfirmationModalOpen: true });
            setNextAction({ nextAction: () => switchNavigationMode(value) });
            return;
        }

        switchNavigationMode(value);
    };

    const switchNavigationMode = (mode: string) => {
        if (isCartEmpty) {
            setCookie(NavigationModeCookieName, mode);
            setNavigationCurrentMode(mode);

            if (mode === "Vmi") {
                vmiDashboardPageUrl && history.push(vmiDashboardPageUrl);
            } else if (cart?.status === "AlternateCart") {
                deleteAlternateCart();
            } else {
                homePageUrl && history.push(homePageUrl);
            }

            onChange?.(mode); // Starter Custom Code

            return;
        }

        if (mode === "Vmi") {
            setCookie(NavigationModeCookieName, currentMode);
            setConfirmModalIsOpen(true);
            setNavigationHeaderText(translate("Continue to VMI"));
            setNavigationMessage(
                <>
                    <Typography {...styles.navigationConfirmMessage}>{siteMessage("Cart_Change_To_Vmi")}</Typography>
                    <Typography {...styles.navigationConfirmQuestion}>
                        {translate("Would you like to continue?")}
                    </Typography>
                </>,
            );
        } else {
            setCookie(NavigationModeCookieName, mode);
            setNavigationCurrentMode(mode);
            if (cart?.status === "AlternateCart") {
                deleteAlternateCart();
            }
            homePageUrl && history.push(homePageUrl);
            onChange?.(mode); // Starter Custom Code
        }

        setNavigationNewMode(mode);
    };

    const deleteAlternateCart = () => {
        removeCart({
            cartId: API_URL_CURRENT_FRAGMENT,
            isAlternateCart: true,
            onSuccess: () => {
                homePageUrl && history.push(homePageUrl);
                loadCurrentCart();
            },
        });
    };

    const createAlternateCart = () => {
        loadVmiLocations({
            ...getVmiLocationsParameter,
            onComplete: ({ apiResult }) => {
                if (!apiResult?.vmiLocations || apiResult.vmiLocations.length === 0) {
                    return;
                }

                const locationId = selectedLocationId ?? apiResult.vmiLocations[0].id;
                addCart({ vmiLocationId: locationId } as AddCartApiParameter).then(() => {
                    loadCurrentCart();
                });
            },
        });
    };

    const changeNavigationModeHandler = () => {
        setCookie(NavigationModeCookieName, navigationNewMode);
        setNavigationCurrentMode(navigationNewMode);

        if (navigationNewMode === "Vmi") {
            createAlternateCart();
            vmiDashboardPageUrl && history.push(vmiDashboardPageUrl);
        } else {
            homePageUrl && history.push(homePageUrl);
        }

        setConfirmModalIsOpen(false);
        onChange?.(navigationNewMode); // Starter Custom Code
    };

    const cancelNavigationModeHandler = () => {
        if (!isCartEmpty && navigationCurrentMode === "Storefront") {
            cartPageLink && history.push(cartPageLink);
        }
        setConfirmModalIsOpen(false);
    };

    const closeNavigationModeHandler = () => {
        setConfirmModalIsOpen(false);
    };

    if (!displayModeSwitch) {
        return null;
    }

    const menuId = "navigationModeMenu";

    return (
        <StyledWrapper {...styles.currencyWrapper} className="navigation-mode-menu" /* Starter Custom Code */>
            {/* Starter Custom Code - Start */}
            <RadioGroup
                label={translate("Navigation Mode")}
                value={navigationCurrentMode}
                onChangeHandler={navigationModeChangeHandler}
                {...styles.radioGroup}
            >
                <Radio value="Storefront" {...styles.radio} disabled={cartRequestInProcess}>
                    {translate("Storefront")}
                </Radio>
                <Radio value="Vmi" {...styles.radio} disabled={cartRequestInProcess}>
                    {translate("Vendor Managed Inventory")}
                </Radio>
            </RadioGroup>
            {/* Starter Custom Code - End */}
            <TwoButtonModal
                headlineText={`${navigationHeaderText}`}
                {...styles.navigationConfirmModal}
                modalIsOpen={confirmModalIsOpen}
                messageText={navigationMessage}
                cancelButtonText={translate("Cancel")} // Starter Custom Code
                submitButtonText={translate("Continue")}
                onCancel={closeNavigationModeHandler} // Starter Custom Code
                onSubmit={changeNavigationModeHandler}
                onClose={closeNavigationModeHandler}
                submitTestSelector="submitNavigationMode"
                // Starter Custom Code
                setOverlayScrimRef={setModalOverlayScrimRef}
            ></TwoButtonModal>
        </StyledWrapper>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(NavigationModeMenu));
